.backdrop {
  position: fixed;
  inset: 0;
  background: rgba(21, 23, 26, 0.5);
  z-index: 40;
  display: flex;
  align-items: flex-end;
}

.sheet {
  width: 100%;
  max-height: 90vh;
  background: var(--bg-page);
  border-radius: 18px 18px 0 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.grabber {
  display: flex;
  justify-content: center;
  padding-top: 8px;
}
.grabberBar {
  width: 40px;
  height: 5px;
  border-radius: var(--r-pill);
  background: var(--border-dashed);
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 6px 8px 16px;
  border-bottom: 1px solid var(--border-1);
}
.title {
  margin: 0;
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 26px;
  text-transform: uppercase;
}
.headerActions {
  display: flex;
  align-items: center;
}
.resetButton {
  height: 44px;
  padding: 0 12px;
  border: 0;
  background: transparent;
  font-size: 15px;
  font-weight: 600;
  color: var(--accent-text);
}
.closeButton {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-primary);
  background: transparent;
  border: 0;
}

.body {
  flex-grow: 1;
  overflow-y: auto;
  padding: 10px 16px 0;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.footer {
  height: 96px;
  flex-shrink: 0;
  background: var(--bg-panel);
  border-top: 1px solid var(--border-1);
  display: flex;
  align-items: center;
  padding: 0 16px 14px;
  box-sizing: border-box;
}
.showButton {
  flex-grow: 1;
  height: 52px;
  border-radius: var(--r-12);
  border: 0;
  background: var(--accent-strong);
  color: #fff;
  font-weight: 700;
  font-size: 19px;
}
